import React from 'react';
import { Modal, Badge, Button } from 'react-bootstrap';
import { formatDate } from '../../../utils/calendarUtils';
import { triggerFestivalCelebration } from '../../../utils/celebrationConfetti';
import './Calendar.css';

const AttendanceDetailModal = ({ show, date, attendance, festival: propFestival, onClose, onEdit, onAddFestival, onDeleteFestival, canManageFestivals, isPrivilegedUser }) => {
  const festival = propFestival || attendance?.festival;

  const getStatusVariant = (status) => {
    const variants = {
      'Present': 'success',
      'Absent': 'danger',
      'Leave': 'warning',
      'Half-day': 'info',
      'WeeklyOff': 'secondary',
      'Holiday': 'primary',
      'Festival': 'light'
    };
    return variants[status] || 'secondary';
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          Attendance Details - {date && formatDate(date)}
          {festival && <span className="ms-2" title="Festival Day">🌈</span>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {festival && (
          <div className="p-3 mb-3 rounded-4 text-white shadow-sm" style={{
            background: 'linear-gradient(90deg, #ff3838 0%, #ff9f1a 20%, #f1c40f 40%, #2ecc71 60%, #00c0ef 80%, #8e44ad 100%)',
            textShadow: '0 1px 2px rgba(0,0,0,0.4)'
          }}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="fs-5 me-1">🎉</span>
                <strong className="fs-6">{festival.name}</strong>
                {festival.description && <div className="small opacity-90 mt-1">{festival.description}</div>}
              </div>
              <div className="d-flex align-items-center gap-2 ms-2">
                {canManageFestivals && (
                  <>
                    {onAddFestival && (
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-pill text-primary fw-bold px-3 shadow-sm border-0"
                        onClick={() => onAddFestival(date)}
                      >
                        Edit Festival
                      </Button>
                    )}
                    {onDeleteFestival && (
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-pill text-danger fw-bold px-3 shadow-sm border-0"
                        onClick={() => onDeleteFestival(festival)}
                      >
                        Remove Festival
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {attendance ? (
          <div className="attendance-details">
            <div className="detail-row">
              <strong>Employee:</strong>
              <span>{attendance.employeeName || 'Selected Staff'}</span>
            </div>
            <div className="detail-row">
              <strong>Status:</strong>
              <div>
                {festival ? (
                  <span className="status-badge festival-rainbow-badge me-2">
                    🎉 {attendance.status === 'Festival' ? 'Festival' : attendance.status}
                  </span>
                ) : (
                  <Badge bg={getStatusVariant(attendance.status)}>
                    {attendance.status}
                  </Badge>
                )}
                {attendance.updatedAt && <span className="ms-2 text-muted" style={{ fontSize: '0.8rem' }}>(Edited)</span>}
              </div>
            </div>
            <div className="detail-row">
              <strong>In Time:</strong>
              <span>{attendance.inTime || '-'}</span>
            </div>
            <div className="detail-row">
              <strong>Out Time:</strong>
              <span>{attendance.outTime || '-'}</span>
            </div>
            <div className="detail-row">
              <strong>Working Hours:</strong>
              <span>{attendance.workingHours ? `${attendance.workingHours} hrs` : '-'}</span>
            </div>
            <div className="detail-row">
              <strong>Overtime:</strong>
              <span>{attendance.overtimeHours ? `${attendance.overtimeHours} hrs` : '-'}</span>
            </div>
            {attendance.notes && (
              <div className="detail-row">
                <strong>Notes:</strong>
                <span>{attendance.notes}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="no-attendance">
            <p className="text-muted mb-0">No attendance punch record found for this date.</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div>
          {!festival && onAddFestival && canManageFestivals && (
            <Button
              variant="outline-warning"
              size="sm"
              className="rounded-pill fw-bold"
              style={{
                borderImage: 'linear-gradient(45deg, #ff3838, #f1c40f, #2ecc71, #00c0ef, #8e44ad) 1',
                color: '#d63384'
              }}
              onClick={() => onAddFestival(date)}
            >
              🎉 Add Festival for this Date
            </Button>
          )}
        </div>
        <div className="d-flex gap-2">
          {attendance && onEdit && isPrivilegedUser && (
            <Button variant="primary" size="sm" className="rounded-pill px-3" onClick={() => onEdit(attendance)}>
              Edit Record
            </Button>
          )}
          <Button variant="secondary" size="sm" className="rounded-pill px-3" onClick={onClose}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export { AttendanceDetailModal };
export default AttendanceDetailModal;
